export function formatEpochToLocalDate(epoch, options = {}) {
  if (!epoch) return "";
  // If epoch is in seconds, convert to milliseconds
  const date = epoch.toString().length === 10
    ? new Date(epoch * 1000)
    : new Date(epoch);
  const defaultOptions = {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  };
  return date.toLocaleString(undefined, { ...defaultOptions, ...options });
}
